import { KEYCLOAK_EVENT_SIGNAL, KeycloakEventType } from 'keycloak-angular';
import Keycloak from 'keycloak-js';
import { take, tap } from 'rxjs';

import { Component, OnInit, ViewChild, effect, inject, signal } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

import { AuthFacade, DialogErrorService, RouteFacade, RxStompService } from '@mitsubishi/core';
import { DialogService } from '@mitsubishi/ui/dialog';
import { ApmSidebarService } from '@mitsubishi/ui/sidebar';
import { MAIN_SPINNER_NAME } from '@mitsubishi/ui/spinner';

import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'apm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  @ViewChild('mainSideNav', { static: true }) private mainSideNav!: MatSidenav;

  mainSpinnerName = MAIN_SPINNER_NAME;
  sidebarService = inject(ApmSidebarService);
  readonly showGlobalWorkingConditions = signal(false);

  readonly #keycloak = inject(Keycloak);
  readonly #keycloakEvent = inject(KEYCLOAK_EVENT_SIGNAL);

  constructor(
    rxStompService: RxStompService,
    dialogErrorService: DialogErrorService,
    dialogService: DialogService,
    authFacade: AuthFacade,
    fontAwesomeLibrary: FaIconLibrary,
    routeFacade: RouteFacade
  ) {
    fontAwesomeLibrary.addIconPacks(fas);
    if (authFacade.isUserAuthenticated) {
      rxStompService.configure();
      rxStompService.activate();
    }

    setTimeout(() => {
      this.showGlobalWorkingConditions.set(routeFacade.data['isPublicRoute'] !== true);
    }, 200);

    dialogErrorService.dialogError$.subscribe(dialogData => {
      dialogService.openErrorDialog(dialogData);
    });

    effect(() => {
      const keycloakEvent = this.#keycloakEvent();

      if (routeFacade.data['isPublicRoute'] === true) {
        return;
      }

      if (keycloakEvent.type === KeycloakEventType.AuthRefreshError) {
        const errorDialogRef = dialogService.openErrorDialog({
          message: 448610, // Session expired
          ignoreOpenedDialogs: true,
        });

        errorDialogRef
          ?.afterClosed()
          .pipe(
            take(1),
            tap(() => {
              this.#keycloak.login({ redirectUri: window.location.href });
            })
          )
          .subscribe();
      }
    });
  }

  ngOnInit() {
    this.sidebarService.setSidenavRef(this.mainSideNav);
  }
}
